import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { observer, inject } from "mobx-react";
import { withSnackbar } from "notistack";
import { withUserProfile } from "../../../../../../../userProfile/userProfileContext";
import { compose } from "recompose";
import {
  getDefaultReceiverDetailsInfo,
  getReceiverDetailsFieldError,
  getReceiverDetailsErrorInfo,
  isReceiverDetailsInValid,
} from "../util";
import Action from "../common/Action";
import ReceiverDetails from "./ReceiverDetails";
import { getDataWithQueryString } from "../../../../../../../api/componentAPIs";
import { withAppConfig } from "../../../../../../../appConfigContext";

const styles = () => ({
  deliveryReceiptContent: {
    padding: "0 24px 24px",
  },
});

@inject("DispatchStore")
@observer
class DeliveryReceipt extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      receiverDetailsInfo: getDefaultReceiverDetailsInfo(
        this.props.stopData.iLine, this.props.receiverDetails
      ),
      customerReceiverList: Object.keys(this.props.receiverDetails).length ? [this.props.receiverDetails] : [],
    };
    this.scacCodeOptions = this.getSCACCodeOptions();
  }

  componentDidMount() {
    if (!this.props.allProsMarkedTA) {
      this.getCustomerReceiver();
    }
  }

  getSCACCodeOptions = () => {
    return (
      this.props.DispatchStore.staticClientData?.clientCodes?.scacCodes?.map(
        (scacCode) => ({
          label: scacCode.code,
          value: scacCode.code,
        }),
      ) ?? []
    );
  };

  getCustomerReceiver = () => {
    const {
      routeData: { routeId },
      stopData: { code: customerCode },
      userData: {
        userProfile: {
          terminal: { code: terminalCode }
        }
      }
    } = this.props;
    getDataWithQueryString(
      "CustomerReceiver",
      `terminalCode=${terminalCode}&routeId=${routeId}&customerCode=${customerCode}`
    ).then((response) => {
      if (response.status === 200) {
        this.setState({
          customerReceiverList:
            response.data[0]?.receiverDetails ?? []
        });
      }
    });
  };

  handleReceiverDetails = (name) => (value) => {
    if (name === "receiverCellPhone") {
      value = Number(value.replace(/\D+/g, ""));
    }
    if (name === "scacCode") {
      value = value && value.value;
    }
    this.setState((prevState) => ({
      ...prevState,
      receiverDetailsInfo: {
        ...prevState.receiverDetailsInfo,
        receiver: {
          ...prevState.receiverDetailsInfo.receiver,
          [name]: value
        },
        receiverError: {
          ...prevState.receiverDetailsInfo.receiverError,
          [name]: getReceiverDetailsFieldError(
            name,
            value,
            this.props.allProsMarkedTA
          )
        }
      }
    }));
  };

  handleReceiverName = (receiverObj) => {
    const { label, value, __isNew__, ...rest } = receiverObj ?? {};
    let newReceiverObj = { ...rest };
    const defaultReceiverDetails = getDefaultReceiverDetailsInfo();
    if (Boolean(__isNew__)) {
      newReceiverObj = {
        ...defaultReceiverDetails.receiver,
        receiverName: label
      };
    }

    this.setState(
      (prevState) => ({
        ...prevState,
        receiverDetailsInfo: {
          receiver: {
            ...newReceiverObj,
          },
          receiverError: {
            ...defaultReceiverDetails.receiverError,
            receiverName: getReceiverDetailsFieldError(
              "receiverName",
              newReceiverObj.receiverName
            ),
          },
        },
      }),
      this.updateCustomerReceiverList(newReceiverObj.receiverName)
    );
  };

  updateCustomerReceiverList = (receiverName) => {
    const customerReceiverList = this.state.customerReceiverList;
    const selectedValue = customerReceiverList.find(
      (customer) => customer.receiverName == receiverName
    );
    if (!selectedValue && receiverName) {
      this.setState({
        customerReceiverList: [
          ...customerReceiverList,
          { receiverName }
        ]
      });
    }
  };

  getAgentDetails = () => {
    const {
      receiverDetailsInfo: {
        receiver: { receiverName, receiverEmail, receiverCellPhone, scacCode }
      }
    } = this.state;
    return {
      agent: {
        name: receiverName,
        email: receiverEmail || null,
        phone: receiverCellPhone || null,
        scacCode
      }
    };
  };

  getReceiverDetails = () => {
    const {
      receiverDetailsInfo: {
        receiver: { receiverId, receiverName, receiverEmail, receiverCellPhone }
      }
    } = this.state;
    if (this.props.allProsMarkedTA) {
      return this.getAgentDetails();
    }
    return {
      receiverId: receiverId || null,
      receiverName: receiverName || null,
      receiverEmail: receiverEmail || null,
      receiverPhone: Number(receiverCellPhone) || null
    };
  };

  createDeliveryReceipt = () => {
    const receiverDetailsInfo = getReceiverDetailsErrorInfo(
      this.state.receiverDetailsInfo.receiver,
      this.props.allProsMarkedTA,
      this.props.configJSON.showTrailerScac
    );
    if (isReceiverDetailsInValid(receiverDetailsInfo)) {
      this.setState({
        receiverDetailsInfo
      });
      return;
    }
    this.props.processDelivery?.(this.getReceiverDetails());
  };

  render() {
    const {
      classes,
      handleClose,
      handlePrevious,
      stopData,
      routeData,
      shipmentList,
      allProsMarkedTA,
      isProcessDeliveryInProgress,
      freightBillData,
      configJSON
    } = this.props;
    return (
      <>
        <div className={classes.deliveryReceiptContent}>
        <ReceiverDetails
            receiverDetailsInfo={this.state.receiverDetailsInfo.receiver}
            receiverDetailsErrorInfo={
              this.state.receiverDetailsInfo.receiverError
            }
            freightBillData={freightBillData}
            handleChange={this.handleReceiverDetails}
            handleReceiverName={this.handleReceiverName}
            stopData={stopData}
            shipmentList={shipmentList}
            routeData={routeData}
            isAgent={allProsMarkedTA}
            scacCodeOptions={this.scacCodeOptions}
            showTrailerScac={configJSON.showTrailerScac}
            customerReceiverList={this.state.customerReceiverList.map(
              (item) => ({
                ...item,
                label: item.receiverName,
                value: item.receiverName
              })
            )}
          />
        </div>
        <Action
          isDisabled={isProcessDeliveryInProgress}
          hasPrevious
          handlePrevious={handlePrevious}
          closeButtonText="Close"
          confirmButtonText="Done"
          handleClose={handleClose}
          handleSubmit={this.createDeliveryReceipt}
        />
      </>
    );
  }
}

export default compose(
  withUserProfile,
  withStyles(styles),
  withSnackbar,
  withAppConfig
)(DeliveryReceipt);
